'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QuestionMarkSquared = require('./QuestionMarkSquared');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_QuestionMarkSquared).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/QuestionMarkSquared/index.js
// module id = 1266
// module chunks = 1